import Vue from 'vue'

// Одно окно просмотра на всё приложение: снимок разворачивают поверх любой
// страницы и любого диалога, и держать это состояние в каждой миниатюре
// незачем — иначе соседние фотографии не знают друг о друге и листать нечего.
export const viewerState = Vue.observable({
  open: false,
  items: [],
  index: 0,
  closeOnBackdrop: true
})

export function openImageViewer (items, index = 0, options = {}) {
  const list = (items || []).filter(Boolean)

  if (!list.length) return

  viewerState.items = list
  viewerState.index = Math.min(Math.max(index, 0), list.length - 1)
  viewerState.closeOnBackdrop = options.closeOnBackdrop !== false
  viewerState.open = true
}

export function closeImageViewer () {
  viewerState.open = false
}

// Листаем по кругу: в группе редко больше десятка снимков, и упираться
// в край на каждом конце неудобнее, чем проскочить на первый.
export function showNextImage (step) {
  const total = viewerState.items.length

  if (total < 2) return

  viewerState.index = (viewerState.index + step + total) % total
}

// Группа для листания — соседние миниатюры: поднимаемся от снимка вверх до
// первого предка, внутри которого их больше одной. Так галереей становится
// именно блок фотографий — ряд в карточке, секция «Повреждения», вложения
// комментария, — а не вся страница разом.
export function collectImageGroup (el) {
  const own = el.querySelector('img')
  let container = el
  let node = el.parentElement

  while (node && node !== document.body) {
    if (node.querySelectorAll('.expandable-image img').length > 1) {
      container = node
      break
    }

    node = node.parentElement
  }

  const images = Array.from(container.querySelectorAll('.expandable-image img'))

  if (!images.length) {
    return { items: own ? [imageSrc(own)] : [], index: 0 }
  }

  return {
    items: images.map(imageSrc),
    index: Math.max(images.indexOf(own), 0)
  }
}

// currentSrc учитывает srcset, но до загрузки он пуст — тогда берём src.
function imageSrc (img) {
  return img.currentSrc || img.src
}
